<section class="section-outset-y container content-block-instagram">
  @if (block.title) {
    <h2 class="h1 mb-0">{{ block.title }}</h2>
  }
  @if (block.text || block.intro) {
    <div [innerHTML]="block.text || block.intro" class="mb-0 markdown-content"></div>
  }

  <ng-content></ng-content>
</section>
